import { Component } from "preact";
// eslint-disable-next-line no-unused-vars
import PropTypes from "prop-types";
import { combineClasses } from "@green24/npm-javascript-utils";
import { FormatUtils } from "../../utils/FormatUtils";
import { withLocalizationContext } from "../components";
import { E_Format_Unit, E_Format_UnitCustom } from "../../models/constants/Enums_FormatUtils";
import Interpret from "./Localization/Interpret";
import { M_Format_Units_ShortToLong } from "../../models/Models_FormatUtils";
import { AppUtils } from "../../utils/AppUtils";

class ValueWithUnit extends Component {
	_renderValueWithCustomUnit(unit, formatOptions) {
		const {value, localizationContext} = this.props;

		return <Interpret id={`unitFormat_${unit}`} params={{
			value: localizationContext.internationalizer.getNumberFormat(formatOptions).format(value),
		}}/>
	}

	_renderValue() {
		const {value, localizationContext, options, maxDecimals} = this.props;
		let {unit} = this.props;
		const formatOptions = {
			maximumFractionDigits: maxDecimals,
			...options,
		}

		if(Object.keys(M_Format_Units_ShortToLong).includes(unit)) {
			unit = M_Format_Units_ShortToLong[unit];
		}

		if(Object.values(E_Format_UnitCustom).includes(unit)) {
			return this._renderValueWithCustomUnit(unit, formatOptions);
		}

		if(!Object.values(E_Format_Unit).includes(unit)) {
			if(AppUtils.isProduction) {
				return `${value} ${unit}`;
			}
			throw Error("Unknown unit: " + unit);
		}

		return FormatUtils.formatWithUnit(value, localizationContext.getActiveLanguageISOCode(), unit, formatOptions);
	}

	render({className, style}) {
		return (
			<span className={combineClasses("value-with-unit", className)} style={style}>
				{this._renderValue()}
			</span>
		);
	}

	static get propTypes() {
		return {
			className: PropTypes.string,
			style: PropTypes.object,
			children: PropTypes.any,

			value: PropTypes.number,
			/**
			 * @type E_Format_Unit
			 */
			unit: PropTypes.oneOf([
				...Object.values(E_Format_Unit),
				...Object.keys(M_Format_Units_ShortToLong)
			]),
			options: PropTypes.object,
			maxDecimals: PropTypes.number,
		}
	}

	static get defaultProps() {
		return {
			maxDecimals: 2,
		}
	}
}

export default withLocalizationContext(ValueWithUnit);
